



















































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {App, AppAssociation, Application, Project} from '@/types';
import SearchBar from '@/components/SearchBar.vue';
import QuicksightDashboard from '@/components/QuicksightDashboard.vue';
import Dialog from '@/components/Dialog.vue';
import DropDown from '@/components/DropDown.vue';
import InstallApplication from '@/components/consume/InstallApplication.vue';
import ApplicationContainer from '@/views/consume/ApplicationContainer.vue';
import AppService from '@/services/apps.service';

@Component({
  components: {
    ApplicationContainer,
    SearchBar,
    QuicksightDashboard,
    Dialog,
    DropDown,
    InstallApplication,
  },
})
export default class Applications extends Vue {
  @Getter private hasPermission: any;
  @Action private addApplicationsAsync: any;
  @Getter private applications!: any;
  @Getter private activeOrganisationId: any;

  private key = 0;
  private installedApplications: AppAssociation[] = [];
  private showAvailableApplications = false;
  private currentApplication: Application | null = null;

  public setCurrentApplication(app: Application) {
    if (app.type.toLowerCase() !== 'daizy') {
      this.$router.push({name: 'consume-app', params: {organisationId: this.activeOrganisationId, id: app.id}});
      this.currentApplication = app;
    }
  }

  private getAppIcon(app: Application): string {
    // TODO Custom icons for each application type.
    switch (app.type) {
      case 'quicksight':
        return 'table-large';
      case 'nodered':
        return 'gauge';
      case 'Daizy':
        return 'pipe';
      default:
        return 'gauge';
    }
  }

  private async mounted() {
    await this.addApplicationsAsync();

    if (this.hasPermission('daizy:debug')) {
      this.installedApplications = await AppService.getInstalledApplications();
    }
    this.currentApplication = null;
  }

  private async reload() {
    this.installedApplications = await AppService.getInstalledApplications();
  }

  private async removeApplication(app: any) {
    await AppService.uninstallApplication(app.id, app.version, app.project_id);
    this.installedApplications = this.installedApplications.filter((a: any) => a.application_id !== app.id);
  }

  get applicationList() {
    return this.applications.applications.map((app: Application) => ({ id: app.id, name: app.name, type: app.type, project: '' }))
      .concat(this.installedApplications.map((assoc: any) => ({ id: assoc.application_id, name: assoc.application.name, type: 'Daizy', project_id: assoc.project_id, version: assoc.version })));
  }
}
